const DISCOUNT_REWARDS = [
  { discount: 10, code: 'QUIZ10', weight: 80 },
  { discount: 12, code: 'DISCOVER12', weight: 15 },
  { discount: 15, code: '15OFF', weight: 5 },
];

const quizSections = document.querySelectorAll('.scent-quiz');
quizSections.forEach(initScentQuiz);

function initScentQuiz(section) {
  const app = section.querySelector('.scent-quiz__app');
  if (!app) return;

  const questionWrap = section.querySelector('[data-quiz-question]');
  const answersWrap = section.querySelector('[data-quiz-answers]');
  const nextBtn = section.querySelector('[data-quiz-next]');
  const backBtn = section.querySelector('[data-quiz-back]');
  const restartBtn = section.querySelector('[data-quiz-restart]');
  const progressFill = section.querySelector('[data-quiz-progress]');
  const progressText = section.querySelector('[data-quiz-progress-text]');
  const resultsWrap = section.querySelector('[data-quiz-results]');
  const questionScreen = section.querySelector('[data-quiz-screen="questions"]');
  const resultsScreen = section.querySelector('[data-quiz-screen="results"]');
  const discountDialog = section.querySelector('[data-quiz-discount-dialog]');
  const discountValue = section.querySelector('[data-quiz-discount-value]');
  const discountCode = section.querySelector('[data-quiz-discount-code]');

  const resultsCount = parseInt(app.dataset.resultsCount || '3', 10);
  const primaryCtaLabel = app.dataset.primaryCtaLabel || '';
  const primaryCtaUrl = app.dataset.primaryCtaUrl || '';
  const secondaryCtaLabel = app.dataset.secondaryCtaLabel || '';
  const secondaryCtaUrl = app.dataset.secondaryCtaUrl || '';

  const questionsJsonEl = section.querySelector('[data-quiz-questions]');
  if (!questionsJsonEl) return;

  let questions = [];
  try {
    questions = JSON.parse(questionsJsonEl.textContent);
  } catch (error) {
    console.error('Failed to parse scent quiz questions JSON', error);
    return;
  }

  questions = questions.filter((question) => {
    return (
      question &&
      question.key &&
      question.title &&
      Array.isArray(question.answers) &&
      question.answers.length > 0
    );
  });

  if (!questions.length) return;

  const products = Array.from(section.querySelectorAll('[data-product]')).map((el) => ({
    handle: el.dataset.handle || '',
    title: el.dataset.title || '',
    url: el.dataset.url || '#',
    image: el.dataset.image || '',
    price: el.dataset.price || '',
    vendor: el.dataset.vendor || '',
    scent_family: normaliseList(el.dataset.scentFamily),
    mood: normaliseList(el.dataset.mood),
    occasion: normaliseList(el.dataset.occasion),
    intensity: normaliseList(el.dataset.intensity),
    style: normaliseList(el.dataset.style),
    starter: normaliseScalar(el.dataset.starter),
    top: el.dataset.top || '',
    heart: el.dataset.heart || '',
    base: el.dataset.base || '',
    curator: el.dataset.curator || '',
  }));

  let currentIndex = 0;
  const state = {};
  let lastClickedAnswerValue = null;

  // Live region for announcing progress and results to screen readers
  const liveRegion = document.createElement('div');
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');
  liveRegion.className = 'scent-quiz__live-region';
  liveRegion.style.position = 'absolute';
  liveRegion.style.left = '-10000px';
  liveRegion.style.width = '1px';
  liveRegion.style.height = '1px';
  liveRegion.style.overflow = 'hidden';
  app.appendChild(liveRegion);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const progressbarEl = section.querySelector('[data-quiz-progressbar]');

  renderQuestion();
  bindEvents();

  function bindEvents() {
    nextBtn.addEventListener('click', () => {
      const question = questions[currentIndex];
      const selections = state[question.key] || [];

      if (!selections.length) return;

      if (currentIndex < questions.length - 1) {
        currentIndex += 1;
        renderQuestion();
      } else {
        renderResults();
      }
    });

    backBtn.addEventListener('click', () => {
      if (currentIndex === 0) return;
      currentIndex -= 1;
      renderQuestion();
    });

    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        Object.keys(state).forEach((key) => delete state[key]);
        currentIndex = 0;
        resultsScreen.hidden = true;
        questionScreen.hidden = false;
        renderQuestion();
        // Return focus to the first answer after restart
        const firstAnswer = answersWrap.querySelector('.scent-quiz__answer');
        if (firstAnswer) firstAnswer.focus();
      });
    }

    if (discountDialog) {
      discountDialog.addEventListener('close', focusResultsHeading);
    }
  }

  function renderQuestion() {
    const question = questions[currentIndex];
    const selectionMode = question.selection_mode === 'single' ? 'single' : 'multi';
    const maxSelections = parseInt(question.max_selections || '1', 10);
    const selectedValues = state[question.key] || [];

    let meta = '';
    if (selectionMode === 'multi') {
      meta = maxSelections > 1 ? `Select up to ${maxSelections}` : 'Select 1';
    } else {
      meta = 'Select 1';
    }

    // Use a description ID for the meta text so it can be referenced
    const metaId = `scent-quiz-meta-${question.key}`;

    questionWrap.innerHTML = '';
    const titleEl = document.createElement('h3');
    titleEl.id = `scent-quiz-question-${question.key}`;
    titleEl.textContent = question.title;
    questionWrap.appendChild(titleEl);

    const metaEl = document.createElement('p');
    metaEl.className = 'scent-quiz__question-meta';
    metaEl.id = metaId;
    metaEl.textContent = meta;
    questionWrap.appendChild(metaEl);

    answersWrap.innerHTML = '';

    question.answers.forEach((answer) => {
      const isSelected = selectedValues.includes(answer.value);
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'scent-quiz__answer';
      button.dataset.answerValue = answer.value;
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      button.id = `scent-quiz-answer-${question.key}-${answer.value}`;

      if (isSelected) {
        button.classList.add('is-selected');
      }

      button.innerHTML = `
        <span class="scent-quiz__answer-title">${escapeHtml(answer.label)}</span>
        ${answer.copy ? `<span class="scent-quiz__answer-copy">${escapeHtml(answer.copy)}</span>` : ''}
      `;

      button.addEventListener('click', () => {
        lastClickedAnswerValue = answer.value;
        const currentSelections = state[question.key] ? [...state[question.key]] : [];

        if (selectionMode === 'single') {
          state[question.key] = [answer.value];
        } else {
          const alreadySelected = currentSelections.includes(answer.value);

          if (alreadySelected) {
            state[question.key] = currentSelections.filter((value) => value !== answer.value);
          } else {
            if (currentSelections.length < maxSelections) {
              state[question.key] = [...currentSelections, answer.value];
            } else {
              state[question.key] = [...currentSelections.slice(1), answer.value];
            }
          }
        }

        // Announce selection state change
        const pressed = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', String(!pressed));

        renderQuestion();
      });

      answersWrap.appendChild(button);
    });

    nextBtn.disabled = !selectedValues.length;
    nextBtn.textContent = currentIndex === questions.length - 1 ? 'See results' : 'Next';
    backBtn.hidden = currentIndex === 0;

    const progress = ((currentIndex + 1) / questions.length) * 100;
    if (!prefersReducedMotion) {
      progressFill.style.width = `${progress}%`;
    } else {
      progressFill.style.width = '100%';
    }
    progressText.textContent = `Question ${currentIndex + 1} of ${questions.length}`;

    // Update progressbar ARIA attributes
    if (progressbarEl) {
      progressbarEl.setAttribute('aria-valuenow', String(Math.round(progress)));
    }

    // Announce progress to screen readers
    liveRegion.textContent = `Question ${currentIndex + 1} of ${questions.length}. ${meta}`;

    // Restore focus after rerender: if an answer was just clicked, focus it;
    // otherwise focus the question heading
    let focusTarget = null;
    if (lastClickedAnswerValue) {
      const clickedButton = answersWrap.querySelector(
        `[data-answer-value="${CSS.escape(lastClickedAnswerValue)}"]`,
      );
      if (clickedButton) focusTarget = clickedButton;
      lastClickedAnswerValue = null;
    }
    if (!focusTarget) {
      const heading = questionWrap.querySelector('h3');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        focusTarget = heading;
      }
    }
    if (focusTarget) focusTarget.focus();
  }

  function renderResults() {
    const scored = products
      .map((product) => ({
        ...product,
        score: scoreProduct(product, state, questions),
      }))
      .sort((a, b) => b.score - a.score)
      .filter((product) => product.score > 0);

    const topResults = scored.slice(0, resultsCount);
    resultsWrap.innerHTML = '';

    if (!topResults.length) {
      resultsWrap.innerHTML = `
        <div class="scent-quiz__empty">
          <p>No close matches came through this time. Try adjusting your answers or browse the full fragrance collection.</p>
        </div>
      `;
    } else {
      topResults.forEach((product) => {
        resultsWrap.appendChild(
          buildResultCard(
            product,
            primaryCtaLabel,
            primaryCtaUrl,
            secondaryCtaLabel,
            secondaryCtaUrl,
          ),
        );
      });
    }

    questionScreen.hidden = true;
    resultsScreen.hidden = false;

    const resultCount = topResults.length;
    const reward = chooseDiscountReward();
    discountValue.textContent = `${reward.discount}% off`;
    discountCode.textContent = reward.code;
    applyDiscountCode(reward.code).catch((error) => {
      console.error('Failed to apply scent quiz discount', error);
    });
    liveRegion.textContent = `Quiz complete. You unlocked ${reward.discount}% off with code ${reward.code}. ${resultCount} recommendation${resultCount !== 1 ? 's' : ''} found.`;

    if (discountDialog && typeof discountDialog.showModal === 'function') {
      discountDialog.showModal();
    } else {
      focusResultsHeading();
    }
  }

  function focusResultsHeading() {
    const resultsHeading = resultsScreen.querySelector('h3');
    if (resultsHeading) {
      resultsHeading.setAttribute('tabindex', '-1');
      resultsHeading.focus();
    }
  }
}

function chooseDiscountReward(randomValue = Math.random()) {
  let threshold = randomValue * 100;

  for (const reward of DISCOUNT_REWARDS) {
    threshold -= reward.weight;
    if (threshold < 0) return reward;
  }

  return DISCOUNT_REWARDS.at(-1);
}

async function applyDiscountCode(code) {
  const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: code }),
  });
  if (!response.ok) throw new Error(`Discount request failed with status ${response.status}`);

  return response.json();
}

function scoreProduct(product, state, questions) {
  let score = 0;

  questions.forEach((question) => {
    const key = question.key;
    const selectedValues = state[key] || [];
    if (!selectedValues.length) return;

    const productValue = product[key];

    if (!Array.isArray(productValue)) {
      if (selectedValues.includes(productValue)) {
        score += 4;
      }
      return;
    }

    const matches = selectedValues.filter((selection) => {
      return selection.split('|').some((value) => productValue.includes(value));
    }).length;

    if (matches > 0) {
      score += 3;
      score += (matches - 1) * 2;
    }
  });

  return score;
}

function buildResultCard(
  product,
  primaryCtaLabel,
  primaryCtaUrl,
  secondaryCtaLabel,
  secondaryCtaUrl,
) {
  const card = document.createElement('article');
  card.className = 'scent-quiz__result-card';

  const imageHtml = product.image
    ? `
      <div class="scent-quiz__result-image">
        <a href="${product.url}">
          <img src="${product.image}" alt="${escapeHtml(product.title)}" width="480" height="480" loading="lazy">
        </a>
      </div>
    `
    : '';

  card.innerHTML = `
    ${imageHtml}
    <div class="scent-quiz__result-content">
      <p class="scent-quiz__result-vendor">${escapeHtml(product.vendor)}</p>
      <h4 class="scent-quiz__result-title">
        <a href="${product.url}">${escapeHtml(product.title)}</a>
      </h4>
      ${product.price ? `<p class="scent-quiz__result-price">${escapeHtml(product.price)}</p>` : ''}
      ${product.curator ? `<p class="scent-quiz__result-meta">${escapeHtml(product.curator)}</p>` : ''}
      ${
        product.top || product.heart || product.base
          ? `
            <p class="scent-quiz__result-notes">
              ${product.top ? `<strong>Top:</strong> ${escapeHtml(product.top)}<br>` : ''}
              ${product.heart ? `<strong>Heart:</strong> ${escapeHtml(product.heart)}<br>` : ''}
              ${product.base ? `<strong>Base:</strong> ${escapeHtml(product.base)}` : ''}
            </p>
          `
          : ''
      }
      <div class="scent-quiz__result-actions">
        <a class="button" href="${product.url}">View fragrance</a>
      </div>
    </div>
  `;

  return card;
}

function normaliseList(value) {
  if (!value) return [];
  return String(value)
    .split(/[|,]/)
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);
}

function normaliseScalar(value) {
  if (!value) return '';
  return String(value).trim().toLowerCase();
}

function escapeHtml(value) {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}
